export function ScrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}
export function ScrollToBottom() {
  window.scrollTo({ top: 1, behavior: 'smooth' });
}
